import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import { AuthService } from '../../services/AuthService';
import './Login.css';
import { useEmpresaLogos } from '../../hooks/useEmpresaLogos';

function Login() {
  const { handleLogin } = useContext(AuthContext);
  const { logos, loadingLogos } = useEmpresaLogos();
  const [documento, setDocumento] = useState('');
  const [password, setPassword] = useState('');
  const [documentoError, setDocumentoError] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDocumentoError('');
    setPasswordError('');

    let valid = true;
    if (!documento.trim()) {
      setDocumentoError('Número de documento es obligatorio');
      valid = false;
    }
    if (!password.trim()) {
      setPasswordError('Contraseña es obligatorio');
      valid = false;
    }

    if (!valid) return;

    setSubmitting(true);
    try {
      const res = await AuthService.login({ documento, password });
      const { success, message } = res;
      if (success) {
        handleLogin(res);
      } else {
        setPasswordError(message || 'Credenciales incorrectas');
      }
    } catch (err) {
      if (err.response) {
        const status = err.response.status;
        const mensaje = err.response.data?.message;

        if (status === 401) {
          setPasswordError(mensaje || 'Credenciales incorrectas');
        } else {
          setPasswordError(mensaje || 'Error inesperado al iniciar sesión');
        }
      } else if (err.request) {
        setPasswordError('No se pudo conectar con el servidor');
      } else {
        setPasswordError('Error desconocido');
      }
    } finally {
      setSubmitting(false);
    }
  };

  if (loadingLogos) {
    return (
      <main className="login-split-container">
        <div className="preloader-fullscreen">
          <div className="spinner"></div>
        </div>
      </main>
    );
  }

  return (
    <main className="login-split-container">
      <div className="login-image-side">
        <img
          src={logos.login_background}
          alt="Background"
          className="main-lcp-image"
        />
        <div className="side-top-logo">
          <img src={logos.logo_dashboard} alt="Logo Blanco" />
        </div>
        <div className="overlay-content">
          <div className="side-text">
            <p>
              Gestiona tus ventas con <br />
              <span className="text-highlight">eficiencia y seguridad.</span>
            </p>
          </div>
        </div>
      </div>


      <div className="login-form-side">
        <div className="login-box-wrapper">
          <form className="login-form" onSubmit={handleSubmit}>
            <div className="mobile-logo">
              <img src={logos.logo_login} alt="Logo" />
            </div>

            <h2 className="login-title">Inicia tu sesión</h2>
            <p className="login-subtitle">Por favor, inicia sesión en tu cuenta</p>

            <div className="input-group">
              <label htmlFor="documento">Documento</label>
              <input id="documento" type="text" placeholder="Número de documento" value={documento} onChange={e => setDocumento(e.target.value)} disabled={submitting} />
              {documentoError && <div className="error">{documentoError}</div>}
            </div>

            <div className="input-group">
              <label htmlFor="password">Contraseña</label>
              <input id="password" type="password" placeholder="********" value={password} onChange={e => setPassword(e.target.value)} disabled={submitting} />
              {passwordError && <div className="error">{passwordError}</div>}
            </div>

            <button type="submit" className="login-btn" disabled={submitting}>
              {submitting ? 'Ingresando...' : 'Ingresar al Sistema'}
            </button>

            <div className="login-footer">
              <Link to="/recuperar-clave" className="recovery-link">¿Olvidaste tu contraseña?</Link>
            </div>
          </form>
        </div>
      </div>
    </main>
  );
}

export default Login;